import { render } from "./ContractSignYellowIcon.vue?vue&type=template&id=6a000b24"
import script from "./ContractSignYellowIcon.vue?vue&type=script&lang=js"
export * from "./ContractSignYellowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__